<template>
  <div class="home_wrap">
    <van-nav-bar
      :title="title"
      left-text=""
      left-arrow
      :fixed="true"
      @click-left="onClickLeft"
    />
    <div class="art">
      <img
        v-if="artNumb == 0"
        style="margin-top:1rem"
        src="../../assets/images/act/art2.png"
        alt=""
      >
      <img
        v-if="artNumb == 1"
        src="../../assets/images/act/art4.png"
        alt=""
      >
      <img
        v-if="artNumb == 2"
        style="margin-top:1rem"
        src="../../assets/images/act/art5.png"
        alt=""
      >
      <img
        v-if="artNumb == 3"
        src="../../assets/images/act/art6.png"
        alt=""
      >
      <div
        v-if="(artNumb == 0 || artNumb == 2) && show"
        class="artTip"
      >
        <div>Recompensas ecebidas: {{ money }} </div>
        <!-- <div class="artButton" v-if="status == 0" @click="receberData">receber</div> -->
      </div>
      <div
        v-if="(artNumb == 0 || artNumb == 2) && !show"
        class="artTip"
        style="left:0.1rem"
      >
        <div>Não há recompensas disponíveis no momento</div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import { NavBar } from "vant";
Vue.use(NavBar);
export default {
  name: "ArticleContent",
  components: {},
  data() {
    return {
      content: "",
      title: "",
      artNumb: null,
      show: true,
      type: 1,
      money: 0,
      status: 0
    };
  },
  created() {
    this.$watch('$route', () => {
      this.loadData(); // 监听路由变化，重新加载数据
    });
  },
  beforeDestroy() { },
  mounted() {
    let data = this.$route.query;
    console.log(data)
    if (data) {
      this.$parent.act_active = this.$route.query.index;
      this.$parent.changeAct(this.$route.query.index);
      if (this.$route.query.index == 1) {
        this.artNumb = 2;
        this.title = ''
        this.type = 0;
        this.getData(this.type);
      } else if (this.$route.query.index == 3) {
        this.artNumb = 1;
        this.title = 'Bónus de apostas PG';
      } else if (this.$route.query.index == 4) {
        this.artNumb = 0;
        this.title = '';
        this.type = 1;
        this.getData(this.type);
      } else if (this.$route.query.index == 5) {
        this.artNumb = 3;
        this.title = ''
      }
    }
  },
  methods: {
    onClickLeft() {
      this.$router.push("/activity");
    },
    loadData() {
      window.location.reload();
    },
    getData(type) {
      Fetch("/Article/detail", {
        type: type
      }, { method: "get" }).then(res => {
        // if(res)
        if (res.data) {
          this.money = res.data.money;
          this.status = res.data.status;
          this.show = true;
        } else {
          this.show = false;
        }
      })
    },
    receberData() {
      Fetch("/Article/receive", {
        type: this.type
      }).then(res => {
        if (res.code == 1) {
          this.loadData();
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";

/deep/ .van-nav-bar {
  background: @primary-color;
}

/deep/ .van-nav-bar .van-icon {
  color: @textcolor1;
}

/deep/ .van-nav-bar__title {
  color: @textcolor1;
}

.art {
  width: 100%;
  padding: 0.2rem;
  box-sizing: border-box;
  margin-top: 1rem;
  margin-bottom: 1rem;
  position: relative;

  img {
    width: 9.8rem;
  }
}

.artTip {
  position: absolute;
  top: 0.5rem;
  left: 0.7rem;
  color: @textcolor1;
  font-size: .38rem;
  // background-color: @primary-color;
  padding: .1rem;
  border-radius: .2rem;
  margin-left: .7rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    background-color: @primary-color;
    padding: .2rem;
    border-radius: .2rem;
  }

  .artButton {
    padding: .2rem;
    background-color: @ButtonColor;
    margin-left: 2rem;
    flex: 1;
    border-radius: .2rem;
    // color: @textcolor4;
  }
}
</style>